module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig1"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pix"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "px"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "402",
      "src": "images/chi-cresswell-fig01_300ppi_bw.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "fighn"
  }, [_vm._v("FIGURE 1.")])]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_vm._v("Corner of Maxwell and Halsted Streets, Chicago, April 1941. Photo by Russell Lee. LC-USF33-012984-M5. Library of Congress, Prints and Photographs Division, FSA/OWI Collection.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd522862","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-cresswell-0007.vue
// module id = 72
// module chunks = 0